import { getApiErrorMessage } from "../../../utils/commonFunction";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */

import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  fetchMyOrderDetailCard,
  fetchMyOrderTimeline,
  fetchVersion,
  fetchLockTimeline,
  // fetchVersion,
} from "../_redux/order/orderAction";

import DiscardDialog from "../../../../_metronic/_partials/widgets/alert/DiscardDialog";
import { Form } from "react-bootstrap";
import SnackBarTool from "../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { canvaCancel } from "../../../utils/canvaCloseFunction";
import {
  containerEdit,
  deleteContainer,
  updateStorageDetail,
  revokeLockAccess,
  addLockAccess,
  fetchAccessTypeOptions,
  updateOrderAccessType,
  cancelPendingAccessType,
} from "../_redux/order/orderCrud";
import ChangeAccessTypeDialog from "./ChangeAccessTypeDialog";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useFormik } from "formik";
import EditDepotModal from "../order-modal/EditDepotModal";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import DeleteDialog from "../../../../_metronic/_partials/widgets/alert/DeleteDialog";
import { Feeds } from "../../../../_metronic/_partials/widgets";
import { CircularProgress } from "@mui/material";
// import { StorageSchema } from "../order-form/validationSchema";
// import "swiper/css/pagination";
// import "swiper/css/navigation";

/**
 * Off-canvas panel showing storage details for an order: container/pod
 * references, depot, lock access, access-type changes, and storage images.
 *
 * @param {object} orderDetail - The order whose storage details are shown.
 * @returns {React.ReactElement} The storage details panel.
 */
export function StorageDetail({ orderDetail }) {
  const dispatch = useDispatch();

  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  const [dialogDis, setDialogDis] = useState(false);
  const [dialog, setDialog] = useState({ check: false });
  const [check, setCheck] = useState(false);
  const [editCon, setEditCon] = useState(null);
  const [dialogDelete, setDialogDelete] = useState(false);
  const [containerDelete, setContainerDelete] = useState(null);
  const [revokingAccess, setRevokingAccess] = useState(false);
  const [addingAccess, setAddingAccess] = useState(false);

  // Lock details state - only addition for lock functionality
  const [lockDetailsView, setLockDetailsView] = useState({
    show: false,
    containerId: null,
    order_container_id: null,
    lockData: null,
  });

  const [accessTypeOptions, setAccessTypeOptions] = useState(null);
  const [accessTypeLoading, setAccessTypeLoading] = useState(false);
  const [pendingAccessTarget, setPendingAccessTarget] = useState(null);
  const [accessSubmitting, setAccessSubmitting] = useState(false);
  const [cancellingPendingAccess, setCancellingPendingAccess] = useState(false);
  const isContainerOrder = orderDetail?.is_container === 1;

  const initialValues = {
    order_id: orderDetail?.id || "",
    pod_data: [],
  };

  const {
    storageImages,
    containerDetail,
    lockTimeline,
    lockTimelineLoading,
  } = useSelector(
    (state) => ({
      storageImages: state.order.versionDetail.storageImages,
      containerDetail: state.order.versionDetail?.containerDetails,
      lockTimeline: state.order.lockTimeline,
      lockTimelineLoading: state.order.lockTimelineLoading,
    }),
    shallowEqual
  );

  // Memoized timeline data - only addition for lock functionality
  const timelineData = useMemo(() => {
    if (lockTimeline && lockTimeline.length > 0) {
      return lockTimeline.map((data) => ({
        ...data,
        created_at: data.timestamp,
        description: data.value,
        type: "lock",
        title: data.title,
      }));
    }
    return [];
  }, [lockTimeline]);

  // Handle lock details view - only addition for lock functionality
  const handleShowLockDetails = useCallback(
    (container) => {
      if (container.lock_id) {
        setLockDetailsView({
          show: true,
          containerId: container.id,
          order_container_id: container.order_container_id,
          lockData: {
            id: container.lock_id,
            display_name: container.lock_display_name,
            serial_number: container.lock_serial_number,
            lock_status: container.lock_status,
          },
        });
        dispatch(fetchLockTimeline(container.lock_id, orderDetail?.id));
      }
    },
    [dispatch, orderDetail?.id]
  );

  // Handle close lock details - only addition for lock functionality
  const handleCloseLockDetails = useCallback(() => {
    setLockDetailsView({
      show: false,
      containerId: null,
      order_container_id: null,
      lockData: null,
    });
  }, []);

  // Close lock details when container details change - only addition for lock functionality
  useEffect(() => {
    if (lockDetailsView.show && containerDetail) {
      const currentContainer = containerDetail.find(
        (container) => container.id === lockDetailsView.containerId
      );
      if (!currentContainer || !currentContainer.lock_id) {
        handleCloseLockDetails();
      }
    }
  }, [
    containerDetail,
    lockDetailsView.show,
    lockDetailsView.containerId,
    handleCloseLockDetails,
  ]);

  /**
   * Load the current access type and the eligible alternatives from the
   * backend. Runs once for DUSS orders when the panel opens. The endpoint
   * also returns price differences so the confirmation dialog can render
   * without a second round-trip.
   */
  const loadAccessTypeOptions = useCallback(() => {
    if (!isContainerOrder || !orderDetail?.id) {
      return;
    }
    setAccessTypeLoading(true);
    fetchAccessTypeOptions(orderDetail.id)
      .then((res) => {
        setAccessTypeOptions(res?.data?.data || null);
      })
      .catch((error) => {
        setAccessTypeOptions(null);
        setSnack({
          call: true,
          type: "error",
          message:
            error?.response?.data?.message ||
            "Could not load access type options. Please try again.",
        });
      })
      .finally(() => {
        setAccessTypeLoading(false);
      });
  }, [isContainerOrder, orderDetail?.id]);

  useEffect(() => {
    loadAccessTypeOptions();
  }, [loadAccessTypeOptions]);

  /**
   * Find a selected option by its Stripe product id. Used by the dialog to
   * resolve the price difference for the chosen target.
   *
   * @param {string} stripeProductId
   * @returns {object|null}
   */
  const findAccessOption = (stripeProductId) => {
    if (!accessTypeOptions?.available_options) return null;
    return (
      accessTypeOptions.available_options.find(
        (option) => option.stripe_product_id === stripeProductId
      ) || null
    );
  };

  /**
   * Open the confirmation dialog for the selected target. The dialog
   * receives the price difference already fetched in the GET response.
   *
   * @param {string} stripeProductId
   */
  const handleAccessTypeSelect = (stripeProductId) => {
    if (!stripeProductId) return;
    const option = findAccessOption(stripeProductId);
    if (option) {
      setPendingAccessTarget(option);
    }
  };

  const closeAccessTypeDialog = () => {
    if (accessSubmitting) return;
    setPendingAccessTarget(null);
  };

  /**
   * Apply or schedule the access-type change. The dialog supplies the
   * apply-at choice ("immediate" or "next_cycle"). On success, refresh the
   * order detail card, the timeline, and the access-type section so the
   * panel reflects the new state. Errors surface via snackbar; the dialog
   * stays open so the agent can retry without losing context.
   *
   * @param {string} applyAt
   */
  const handleAccessTypeConfirm = (applyAt) => {
    if (!pendingAccessTarget || !orderDetail?.id) return;
    setSnack({ call: false, type: "", message: "" });
    setAccessSubmitting(true);
    updateOrderAccessType(orderDetail.id, {
      target_stripe_product_id: pendingAccessTarget.stripe_product_id,
      apply_at: applyAt,
    })
      .then((res) => {
        setSnack({ call: true, type: "success", message: res.data.message });
        dispatch(fetchMyOrderDetailCard(orderDetail.id));
        dispatch(fetchMyOrderTimeline(orderDetail.id));
        setPendingAccessTarget(null);
        loadAccessTypeOptions();
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message:
            error?.response?.data?.message ||
            "Could not update access type. Please try again.",
        });
      })
      .finally(() => {
        setAccessSubmitting(false);
      });
  };

  /**
   * Cancel a pending next-cycle access-type change before it activates.
   * On success, refresh the timeline and access-type section. Errors
   * surface via snackbar; the banner stays so the agent can retry.
   */
  const handleCancelPendingAccess = () => {
    if (!orderDetail?.id || cancellingPendingAccess) return;
    setSnack({ call: false, type: "", message: "" });
    setCancellingPendingAccess(true);
    cancelPendingAccessType(orderDetail.id)
      .then((res) => {
        setSnack({ call: true, type: "success", message: res.data.message });
        dispatch(fetchMyOrderDetailCard(orderDetail.id));
        dispatch(fetchMyOrderTimeline(orderDetail.id));
        loadAccessTypeOptions();
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message:
            error?.response?.data?.message ||
            "Could not cancel pending change. Please try again.",
        });
      })
      .finally(() => {
        setCancellingPendingAccess(false);
      });
  };

  // useEffect(() => {
  //   if (orderDetail.id) {
  //     dispatch(fetchVersion(orderDetail.franchise_id, orderDetail.id));
  //   }
  // }, [dispatch, orderDetail.franchise_id, orderDetail.id]);
  const handleContainerUpdate = () => {
    setSnack({ call: false, type: "", message: "" });
    const data = {
      order_id: orderDetail.id,
      franchise_container_id: editCon?.value?.id,
      reference_unique_id: editCon?.reference_unique_id,
    };
    containerEdit(data)
      .then((res) => {
        setEditCon(null);
        setSnack({ call: true, type: "success", message: res.data.message });
        dispatch(fetchVersion(orderDetail.franchise_id, orderDetail.id));
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      });
  };

  const handleSubmit = (values) => {
    setSnack({ call: false, type: "", message: "" });

    updateStorageDetail(values)
      .then((res) => {
        dispatch(fetchMyOrderDetailCard(orderDetail?.id));
        dispatch(fetchMyOrderTimeline(orderDetail?.id));
        setSnack({ call: true, type: "success", message: res.data.message });
        canvaCancel("kt_StorageDetail_panel_close");
        formik.setTouched({});
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      });
  };
  const handleReset = () => {};

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    // validationSchema: StorageSchema,
    onSubmit: handleSubmit,
    onReset: handleReset,
  });

  const handleSetData = (value) => {
    const arr = [];
    value.forEach((e, index) => {
      arr.push({
        id: e?.id || "",
        pod_number: e?.pod_number || "",
        seal_number_one: e?.seal_number_one || "",
        seal_number_two: e?.seal_number_two || "",
      });
    });

    formik.setFieldValue("pod_data", arr);
  };

  useEffect(() => {
    if (
      orderDetail?.pod_storage_details &&
      orderDetail?.pod_storage_details.length > 0
    ) {
      handleSetData(orderDetail?.pod_storage_details);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    orderDetail?.pod_storage_details,
    formik?.values?.pod_data?.length,
    check,
  ]);

  const handleDiscard = () => {
    if (
      formik.dirty &&
      Object.keys(formik.touched).length !== 0 &&
      formik.isValid
    ) {
      setDialogDis(true);
    } else {
      canvaCancel("kt_StorageDetail_panel_close");
      formik.resetForm();
    }
  };

  const handleDelete = () => {
    setSnack({ call: false, type: "", message: "" });
    const data = {
      order_id: orderDetail.id,
      franchise_container_id: containerDelete?.value?.id,
    };
    deleteContainer(data)
      .then((res) => {
        dispatch(fetchMyOrderTimeline(orderDetail?.id));
        dispatch(fetchVersion(orderDetail.franchise_id, orderDetail.id));
        setSnack({ call: true, type: "success", message: res.data.message });
        setDialogDelete(false);
      })
      .catch((error) => {
        setDialogDelete(false);

        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      });
  };

  const StatusBadge = React.memo(({ status }) => {
    const isActive = status === "Active";
    const statusClass = isActive ? "success" : "danger";
    const statusText = isActive ? "Active" : "Inactive";

    return (
      <span
        className={`label label-lg label-light-${statusClass} label-inline`}
      >
        {statusText}
      </span>
    );
  });

  const handleRevokeAccess = () => {
    setRevokingAccess(true);
    const data = {
      order_id: orderDetail?.id,
      order_container_id: lockDetailsView.order_container_id,
    };
    revokeLockAccess(data)
      .then((res) => {
        setSnack({ call: true, type: "success", message: res.data.message });
        dispatch(fetchVersion(orderDetail.franchise_id, orderDetail.id));
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      })
      .finally(() => {
        setRevokingAccess(false);
      });
  };

  const handleAddLockAccess = (container) => {
    setAddingAccess(true);
    const data = {
      order_id: orderDetail?.id,
      order_container_id: container.order_container_id,
    };
    addLockAccess(data)
      .then((res) => {
        setSnack({ call: true, type: "success", message: res.data.message });
        dispatch(fetchVersion(orderDetail.franchise_id, orderDetail.id));
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      })
      .finally(() => {
        setAddingAccess(false);
      });
  };

  return (
    <div
      id="kt_StorageDetail_panel"
      className="offcanvas offcanvas-right pt-5 pb-10"
    >
      {/*begin::Header*/}
      <div className="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
        <div
          className="offcanvas-close mt-n1 pr-5"
          style={{ position: "absolute", top: "15px", right: "10px" }}
        >
          <span
            onClick={() => handleDiscard()}
            className="btn btn-xs btn-icon btn-light btn-hover-primary"
          >
            <i className="ki ki-close icon-sm text-muted"></i>
          </span>
        </div>
        <div id="kt_StorageDetail_panel_close"></div>
      </div>
      {/*end::Header*/}
      <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
        <div className=" px-10">
          <div>
            <h5>Storage Details</h5>
          </div>
          <div
            id="kt_quick_panel_logs_kt_StorageDetail_panel"
            className=" fade pt-3 pr-5 mr-n5 scroll active show ps--active-y"
          >
            {orderDetail?.is_container === 1 ? (
              <div className="mt-10">
                {containerDetail && containerDetail.length > 0 ? (
                  containerDetail.map((e, index) => (
                    <div className="d-flex align-items-center  storage-option">
                      <div>Container Reference Number:&nbsp;</div>
                      {editCon?.edit === index ? (
                        <div>
                          <Form.Control
                            type="text"
                            name={`pod_data`}
                            value={editCon?.reference_unique_id}
                            onChange={(e) =>
                              setEditCon({
                                ...editCon,
                                reference_unique_id: e.target.value,
                              })
                            }
                          />
                        </div>
                      ) : (
                        <div>
                          <strong>{e.reference_unique_id}</strong>
                        </div>
                      )}
                      <div>
                        &nbsp;
                        {editCon?.edit === index ? (
                          <button
                            type="button"
                            className="btn btn-primary font-weight-bolder font-size-sm "
                            onClick={() => {
                              handleContainerUpdate();
                            }}
                          >
                            Save
                          </button>
                        ) : (
                          <>
                            <span className="symbol-label ml-2">
                              <span
                                className="svg-icon svg-icon-sm svg-icon-primary "
                                role="button"
                                onClick={() => {
                                  setEditCon({
                                    value: e,
                                    edit: index,
                                    reference_unique_id: e?.reference_unique_id,
                                  });
                                }}
                              >
                                <SVG
                                  title=" "
                                  className="h-25 align-self-end"
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Design/Edit.svg"
                                  )}
                                ></SVG>
                              </span>
                            </span>
                            <span className="symbol-label ml-2">
                              <span
                                className="svg-icon svg-icon-sm svg-icon-primary "
                                role="button"
                                onClick={() => {
                                  setDialogDelete(true);
                                  setContainerDelete({ value: e });
                                }}
                              >
                                <SVG
                                  title=" "
                                  className="h-25 align-self-end"
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Trash.svg"
                                  )}
                                ></SVG>
                              </span>
                            </span>
                            {/* Lock Details Button - only addition for lock functionality */}
                            {e.lock_id ? (
                              <span className="symbol-label ml-2">
                                <span
                                  className="svg-icon svg-icon-sm svg-icon-primary "
                                  role="button"
                                  onClick={() => handleShowLockDetails(e)}
                                  title="Show Lock Details"
                                >
                                  <SVG
                                    title="Lock Details"
                                    className="h-25 align-self-end"
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Home/Key.svg"
                                    )}
                                  ></SVG>
                                </span>
                              </span>
                            ) : (
                              <button
                                className="btn btn-primary btn-sm ml-2"
                                onClick={() => handleAddLockAccess(e)}
                                disabled={addingAccess}
                              >
                                {addingAccess ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm mr-2" />{" "}
                                    Adding Lock Access...
                                  </>
                                ) : (
                                  "Grant Lock Access"
                                )}
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="d-flex align-items-center  storage-option">
                    <div>No Container Available </div>
                  </div>
                )}

                {/* Lock Details View - only addition for lock functionality */}
                {lockDetailsView.show && lockDetailsView.lockData && (
                  <div className="mt-5">
                    <div
                      className="card card-custom"
                      style={{ border: "1px solid #EBEDF3" }}
                    >
                      <div
                        className="card-header d-flex justify-content-between align-items-center"
                        style={{ backgroundColor: "#fe6601", padding: "8px" }}
                      >
                        <h3 className="card-title">
                          <span className="font-weight-bolder text-light">
                            Lock Details
                          </span>
                        </h3>
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-light"
                          onClick={handleCloseLockDetails}
                        >
                          <i className="ki ki-close icon-sm"></i>
                        </button>
                      </div>
                      <div className="card-body">
                        <div className="row mb-4">
                          <div className="col-md-6">
                            <p className="mb-4">
                              <strong>Lock Name:</strong>{" "}
                              {lockDetailsView.lockData?.display_name}
                            </p>
                          </div>
                          <div className="col-md-3">
                            <p className="mb-4">
                              <strong>Status:</strong>{" "}
                              <StatusBadge
                                status={lockDetailsView.lockData?.lock_status}
                              />
                            </p>
                          </div>
                          <div className="col-md-3">
                            <button
                              className="btn btn-primary btn-sm mb-4"
                              onClick={handleRevokeAccess}
                              disabled={revokingAccess}
                            >
                              {revokingAccess ? (
                                <>
                                  <span className="spinner-border spinner-border-sm mr-2" />{" "}
                                  Revoking Access...
                                </>
                              ) : (
                                "Revoke Access"
                              )}
                            </button>
                          </div>
                          <div className="col-md-6">
                            <p className="mb-4">
                              <strong>Serial Number:</strong>{" "}
                              {lockDetailsView.lockData?.serial_number}
                            </p>
                          </div>
                        </div>
                        {/* Timeline */}
                        {lockTimelineLoading ? (
                          <div className="text-center">
                            <CircularProgress />
                            <p className="text-muted mt-2">
                              Loading timeline...
                            </p>
                          </div>
                        ) : (
                          <div>
                            <Feeds
                              classNameSend="card-stretchs"
                              data={timelineData}
                              type={"lock"}
                              title={`Lock Timeline - ${lockDetailsView.lockData?.display_name}`}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {accessTypeOptions?.current && (
                  <div className="mt-10">
                    <h5>Access Type</h5>
                    <div className="d-flex align-items-center storage-option mt-3">
                      <div>Current:&nbsp;</div>
                      <div>
                        <strong>{accessTypeOptions.current.label}</strong>
                      </div>
                    </div>
                    {accessTypeOptions.pending ? (
                      <div className="alert alert-warning mt-3 mb-0">
                        <p className="mb-1">
                          Pending change to{" "}
                          <strong>{accessTypeOptions.pending.label}</strong>
                          {accessTypeOptions.pending.effective_at && (
                            <>
                              {" "}effective{" "}
                              <strong>
                                {new Date(
                                  accessTypeOptions.pending.effective_at
                                ).toLocaleDateString("en-GB")}
                              </strong>
                            </>
                          )}
                          .
                        </p>
                        <button
                          type="button"
                          className="btn btn-sm btn-light btn-elevate mt-2"
                          onClick={handleCancelPendingAccess}
                          disabled={cancellingPendingAccess}
                        >
                          {cancellingPendingAccess ? (
                            <>
                              <span className="spinner-border spinner-border-sm mr-2" />
                              Cancelling...
                            </>
                          ) : (
                            "Cancel pending change"
                          )}
                        </button>
                      </div>
                    ) : (
                      accessTypeOptions.available_options?.length > 0 && (
                        <div className="d-flex align-items-center storage-option mt-3">
                          <div>Change to:&nbsp;</div>
                          <div style={{ minWidth: 280 }}>
                            <Form.Control
                              as="select"
                              value=""
                              disabled={accessTypeLoading}
                              onChange={(event) =>
                                handleAccessTypeSelect(event.target.value)
                              }
                            >
                              <option value="">Select alternative...</option>
                              {accessTypeOptions.available_options.map(
                                (option) => (
                                  <option
                                    key={option.stripe_product_id}
                                    value={option.stripe_product_id}
                                  >
                                    {option.label}
                                  </option>
                                )
                              )}
                            </Form.Control>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="mt-10">
                {formik?.values?.pod_data &&
                  formik.values?.pod_data.length > 0 &&
                  formik.values?.pod_data.map((item, index) => (
                    <div
                      className="row storage mb-5 mr-2 ml-2"
                      key={index}
                      style={
                        orderDetail?.pod_storage_details[index]?.is_initial ===
                        1
                          ? { backgroundColor: "#c8e1c8" }
                          : orderDetail?.pod_storage_details[index]
                              ?.is_initial === 2 ||
                            orderDetail?.pod_storage_details[index]
                              ?.is_return === 1
                          ? { backgroundColor: "#e9bebe" }
                          : {}
                      }
                    >
                      <div className="col-sm-4 mt-2 mb-2">
                        <div className="d-flex justify-content-between align-items-center storage-option">
                          <div>
                            {" "}
                            {orderDetail?.is_container === 1
                              ? "Container"
                              : "Pod"}{" "}
                            Number:
                          </div>
                          <div>
                            <Form.Control
                              type="text"
                              name={`pod_data[${index}].pod_number`}
                              values={item.pod_number}
                              {...formik.getFieldProps(
                                `pod_data[${index}].pod_number`
                              )}
                              disabled={
                                orderDetail?.pod_storage_details[index]
                                  ?.is_initial === 2
                              }
                            />
                          </div>
                        </div>

                        {formik.touched.pod_data && formik.errors.pod_data ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik?.errors?.pod_data[index]?.pod_number ||
                                ""}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-sm-4 mt-2 mb-2">
                        <div className="d-flex justify-content-between align-items-center storage-option">
                          <div>Seal Number 1: </div>
                          <div>
                            <Form.Control
                              type="text"
                              values={item.seal_number_one}
                              name={`pod_data[${index}].seal_number_one`}
                              {...formik.getFieldProps(
                                `pod_data[${index}].seal_number_one`
                              )}
                              disabled={
                                orderDetail?.pod_storage_details[index]
                                  ?.is_initial === 2
                              }
                            />
                          </div>
                        </div>
                        {formik.touched.pod_data && formik.errors.pod_data ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik?.errors?.pod_data[index]
                                ?.seal_number_one || ""}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="col-sm-4 mt-2 mb-2">
                        <div className="d-flex justify-content-between align-items-center storage-option">
                          <div>Seal Number 2:</div>
                          <div>
                            <Form.Control
                              type="text"
                              values={item.seal_number_two}
                              name={`pod_data[${index}].seal_number_two`}
                              {...formik.getFieldProps(
                                `pod_data[${index}].seal_number_two`
                              )}
                              disabled={
                                orderDetail?.pod_storage_details[index]
                                  ?.is_initial === 2
                              }
                            />
                          </div>
                        </div>
                        {formik.touched.pod_data && formik.errors.pod_data ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik?.errors?.pod_data[index]
                                ?.seal_number_two || ""}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ))}

                <div className="d-flex justify-content-between w-50">
                  <h5>Depot</h5>
                  <span className="symbol-label pointer">
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => setDialog({ check: true })}
                    >
                      <span className="svg-icon svg-icon-sm svg-icon-primary">
                        <SVG
                          title=" "
                          className="h-25 align-self-end"
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Design/Edit.svg"
                          )}
                        ></SVG>
                      </span>
                    </button>
                  </span>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <p className="marginBottom0">
                      <strong>Name:-</strong>{" "}
                      {orderDetail?.depot_details?.name || ""}
                    </p>
                    <p className="marginBottom0">
                      <strong>Address:-</strong>{" "}
                      {orderDetail?.depot_details?.address_line_1 || ""}
                    </p>

                    <p className="marginBottom0">
                      {orderDetail?.depot_details?.address_line_2 || ""}
                    </p>

                    <p className="marginBottom0">
                      {orderDetail?.depot_details?.address_line_3 || ""}
                    </p>

                    <p className="marginBottom0">
                      {orderDetail?.depot_details?.city || ""}
                    </p>

                    <p className="marginBottom0">
                      {orderDetail?.depot_details?.postcode || ""}
                    </p>
                  </div>
                </div>
                <Swiper
                  pagination={{
                    el: ".swiper-custom-pagination",
                    type: "fraction",
                  }}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper"
                >
                  {storageImages && storageImages.length > -1
                    ? storageImages.map((item, index) => (
                        <SwiperSlide key={index}>
                          <img src={item?.image} alt="hello" />
                        </SwiperSlide>
                      ))
                    : ""}

                  {/* <SwiperSlide>Slide 2</SwiperSlide>
                <SwiperSlide>Slide 3</SwiperSlide>
                <SwiperSlide>Slide 4</SwiperSlide>
                <SwiperSlide>Slide 5</SwiperSlide>
                <SwiperSlide>Slide 6</SwiperSlide>
                <SwiperSlide>Slide 7</SwiperSlide>
                <SwiperSlide>Slide 8</SwiperSlide>
                <SwiperSlide>Slide 9</SwiperSlide> */}
                </Swiper>
                <div className="swiper-custom-pagination text-center" />
              </div>
            )}
            <div className="mt-2">
              <hr />
            </div>
            {orderDetail?.is_container === 1 && (
              <div className="mt-10">
                <h5>Add Container</h5>
                <div className="d-flex align-items-center  storage-option">
                  <div>Container Reference Number:&nbsp;</div>
                  <div>
                    <Form.Control
                      type="text"
                      name={`pod_data`}
                      value={editCon?.reference_unique_id}
                      onChange={(e) =>
                        setEditCon({
                          ...editCon,
                          reference_unique_id: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div>
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-primary font-weight-bolder font-size-sm "
                      onClick={() => {
                        handleContainerUpdate();
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="offcanvas-footer">
          <div className="offcanvas-content text-right ">
            <button
              className="btn btn-dark font-weight-bolder font-size-sm mr-3 "
              type="button"
              onClick={() => handleDiscard()}
            >
              Cancel
            </button>
            {orderDetail?.is_container !== 1 && (
              <button
                type="submit"
                className="btn btn-primary font-weight-bolder font-size-sm "
              >
                Save
              </button>
            )}
          </div>
        </div>
      </form>
      <DiscardDialog
        setDialogDis={setDialogDis}
        dialogDis={dialogDis}
        formik={formik}
        setCheck={setCheck}
        closeId={"kt_StorageDetail_panel_close"}
      />
      <EditDepotModal
        orderDetail={orderDetail}
        dialog={dialog}
        setDialog={setDialog}
      />
      <DeleteDialog
        dialog={dialogDelete}
        setDialog={setDialogDelete}
        handleDelete={handleDelete}
        title={"Container"}
      />
      <ChangeAccessTypeDialog
        show={Boolean(pendingAccessTarget)}
        onCancel={closeAccessTypeDialog}
        onConfirm={handleAccessTypeConfirm}
        submitting={accessSubmitting}
        fromLabel={accessTypeOptions?.current?.label || ""}
        toLabel={pendingAccessTarget?.label || ""}
        priceDifference={pendingAccessTarget?.price_difference}
        currencySymbol={orderDetail?.currency === "GBP" ? "£" : ""}
        periodUnit={pendingAccessTarget?.price?.period_unit}
      />
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </div>
  );
}
